import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { arrowCircleUpRightLine } from "@tql/ui-components-react/untitled/icons";
import { useMemo } from "react";
import { Link } from "react-router";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type { BoardColumn } from "~/shared/types/quote-board-types.ts";

import type { ReportItem } from "../types/report-types.ts";

export function useReportColumns() {
	const columns: BoardColumn[] = useMemo(
		() => [
			{
				field: "name",
				title: "Report Name",
				show: true,
				editable: false,
				sortable: false,
				width: 200,
			},
			{
				title: "Actions",
				show: true,
				width: 200,
				fixedWidth: true,
				editable: false,
				sortable: false,
				filterable: false,
				cells: {
					data: (props: GridCustomCellProps) => {
						const report = props.dataItem as ReportItem;
						const reportPath = `/reports/${report.id}`;
						return (
							<GridTd tdProps={props.tdProps}>
								<Link style={{ textDecoration: "none" }} to={reportPath}>
									<Button svgIcon={arrowCircleUpRightLine} variant={"tertiary"}>
										Launch Report
									</Button>
								</Link>
							</GridTd>
						);
					},
				},
			},
			{
				field: "details",
				title: "Details",
				show: true,
				editable: false,
				sortable: false,
			},
		],
		[],
	);

	return columns;
}
